import Swiper from "swiper/swiper-bundle.js";
import "../polyfills/is-nan";
import "../polyfills/for-each";

const initRecommendationsSlider = () => {
  const sliderContainers = document.querySelectorAll(
    ".js-recommended-products"
  );

  if (sliderContainers == null) {
    return;
  }

  sliderContainers.forEach((sliderContainer) => {
    const slider = sliderContainer.querySelector(".swiper-container");
    const pagination = sliderContainer.querySelector(".slider__pagination");

    const mySlider = new Swiper(slider, {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 10,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: ".custom-swiper-arrows__next",
        prevEl: ".custom-swiper-arrows__prev",
      },
      breakpoints: {
        1020: {
          slidesPerView: 4,
        },
      },
    });
  });
};

if ($(".product-recommendations").length) {
  // mutation observer
  let configMutationRecommended = {
    attributes: false,
    childList: true,
    characterData: false,
  };
  let recommended = document.getElementById(
    "shopify-section-product-recommendations"
  );
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      initRecommendationsSlider();
    });
  });

  observer.observe(recommended, configMutationRecommended);
}

if ($(".recommended-slider-js").length || $(".js-new-arrivals").length) {
  initRecommendationsSlider();
}
